"use strict";

require("core-js/modules/esnext.global-this.js");
require("core-js/modules/es.promise.finally.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_PROVIDERS = void 0;
exports.collectEvent = collectEvent;
exports["default"] = void 0;
exports.getMandatoryProperties = getMandatoryProperties;
exports.group = group;
exports.identify = identify;
exports.incrementUserProperty = incrementUserProperty;
exports.isInitialized = isInitialized;
exports.isLoading = isLoading;
exports.isReady = isReady;
exports.reset = reset;
exports.sendEvent = sendEvent;
exports.sendEventWithCache = sendEventWithCache;
exports.sendOrder = sendOrder;
exports.sendPage = sendPage;
exports.setCollectUntrackedEvents = setCollectUntrackedEvents;
exports.setUserProperties = setUserProperties;
exports.trackAbTest = trackAbTest;
exports.trackAccountSwitched = trackAccountSwitched;
exports.trackAnswerChanged = trackAnswerChanged;
exports.trackAutobrandingApi = trackAutobrandingApi;
exports.trackBlockDefined = trackBlockDefined;
exports.trackBlockDeleted = trackBlockDeleted;
exports.trackBrowserZoomed = trackBrowserZoomed;
exports.trackChangeDesign = trackChangeDesign;
exports.trackCreateTypeform = trackCreateTypeform;
exports.trackFeatureActivated = trackFeatureActivated;
exports.trackFeatureDiscovered = trackFeatureDiscovered;
exports.trackFeatureFirstStepAdopted = trackFeatureFirstStepAdopted;
exports.trackGenerativeAiApi = trackGenerativeAiApi;
exports.trackIntegrationSetup = trackIntegrationSetup;
exports.trackIntegrationUsed = trackIntegrationUsed;
exports.trackItemClicked = trackItemClicked;
exports.trackLoginRedirected = trackLoginRedirected;
exports.trackMarketingPurchaseCompleted = trackMarketingPurchaseCompleted;
exports.trackMediaQuestionDefined = trackMediaQuestionDefined;
exports.trackMenuOpened = trackMenuOpened;
exports.trackMessageShown = trackMessageShown;
exports.trackModalOpened = trackModalOpened;
exports.trackPageClosed = trackPageClosed;
exports.trackPageNavigated = trackPageNavigated;
exports.trackPanelOpened = trackPanelOpened;
exports.trackPopupClosed = trackPopupClosed;
exports.trackPopupOpened = trackPopupOpened;
exports.trackPresentConversation = trackPresentConversation;
exports.trackProTrialStarted = trackProTrialStarted;
exports.trackPublishTypeform = trackPublishTypeform;
exports.trackPublishTypeformFailed = trackPublishTypeformFailed;
exports.trackSaveFailed = trackSaveFailed;
exports.trackSearchQueryEntered = trackSearchQueryEntered;
exports.trackSearchQueryRemoved = trackSearchQueryRemoved;
exports.trackStartConversation = trackStartConversation;
exports.trackSurfaceOpened = trackSurfaceOpened;
exports.trackTmpItemClicked = trackTmpItemClicked;
exports.trackTmpMessageShown = trackTmpMessageShown;
exports.trackTmpPageNavigated = trackTmpPageNavigated;
exports.trackTmpPopupOpened = trackTmpPopupOpened;
exports.trackTmpUseFeature = trackTmpUseFeature;
exports.trackTmpViewPageSection = trackTmpViewPageSection;
exports.trackTypeformDeleted = trackTypeformDeleted;
exports.trackTypeformModeChanged = trackTypeformModeChanged;
exports.trackUseFeature = trackUseFeature;
exports.trackVaXsellingClicked = trackVaXsellingClicked;
exports.trackVaXsellingViewed = trackVaXsellingViewed;
exports.trackViewPageSection = trackViewPageSection;
exports.trackWorkspaceCreated = trackWorkspaceCreated;
exports.updateMandatoryProperties = updateMandatoryProperties;
exports.updateWidget = updateWidget;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
var _logger = _interopRequireDefault(require("./logger"));
var _consentUtil = require("./consents/consentUtil");
var _snippetGtm = require("./snippet-gtm");
var _isUserAgentFromABot = require("./utils/is-user-agent-from-a-bot");
var _excluded = ["attribution_uid", "distribution_channel"],
  _excluded2 = ["attribution_uid", "distribution_channel"],
  _excluded3 = ["test_id", "variant_id", "variant_label"],
  _excluded4 = ["category"],
  _excluded5 = ["category"],
  _excluded6 = ["category"],
  _excluded7 = ["category"],
  _excluded8 = ["category"],
  _excluded9 = ["category"],
  _excluded10 = ["category"],
  _excluded11 = ["category"],
  _excluded12 = ["category"],
  _excluded13 = ["category"],
  _excluded14 = ["category"],
  _excluded15 = ["category"],
  _excluded16 = ["category"],
  _excluded17 = ["category"],
  _excluded18 = ["category"],
  _excluded19 = ["category"],
  _excluded20 = ["category"],
  _excluded21 = ["category"],
  _excluded22 = ["category"],
  _excluded23 = ["category", "page", "section"],
  _excluded24 = ["category"],
  _excluded25 = ["category"],
  _excluded26 = ["category"],
  _excluded27 = ["category", "test_id", "feature"],
  _excluded28 = ["category", "test_id", "popup"],
  _excluded29 = ["category", "test_id", "item"],
  _excluded30 = ["category", "test_id", "page", "section"],
  _excluded31 = ["category", "test_id", "message"],
  _excluded32 = ["category"],
  _excluded33 = ["test_id", "item", "value", "location"],
  _excluded34 = ["item", "location", "page", "section"],
  _excluded35 = ["page", "section", "category"],
  _excluded36 = ["zoom_type", "zoom_percentage", "category"],
  _excluded37 = ["category"],
  _excluded38 = ["category"],
  _excluded39 = ["api_call_response", "company_website", "category"],
  _excluded40 = ["category"],
  _excluded41 = ["category"],
  _excluded42 = ["category"],
  _excluded43 = ["category"],
  _excluded44 = ["category"],
  _excluded45 = ["category"],
  _excluded46 = ["category"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var SUPPORTED_PROVIDERS = exports.SUPPORTED_PROVIDERS = {
  RUDDERSTACK: _constants.RUDDERSTACK,
  SEGMENT: _constants.SEGMENT
};
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}
var settings = {
  dataLayerPush: false,
  providers: (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.SEGMENT, {
    isLoading: function isLoading() {
      return !!window.analytics && !isReady(_constants.SEGMENT);
    },
    initialized: function initialized() {
      var _window, _window$analytics;
      return ((_window = window) === null || _window === void 0 || (_window = _window.analytics) === null || _window === void 0 ? void 0 : _window.invoked) || ((_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.initialized);
    },
    ready: function ready() {
      var _window$analytics2, _window$analytics3;
      return !!((_window$analytics2 = window.analytics) !== null && _window$analytics2 !== void 0 && _window$analytics2.initialized) && !!((_window$analytics3 = window.analytics) !== null && _window$analytics3 !== void 0 && _window$analytics3.allInitsReady);
    }
  }), _constants.RUDDERSTACK, {
    isLoading: function isLoading() {
      return !!window.rudderanalytics && !isInitialized(_constants.RUDDERSTACK);
    },
    initialized: function initialized() {
      var _window2;
      return (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.rudderanalytics) === null || _window2 === void 0 ? void 0 : _window2.initialized;
    },
    ready: function ready() {
      return isInitialized(_constants.RUDDERSTACK);
    }
  }),
  collectUntrackedEvents: true
};
var userData = {
  email: null
};
var cachedProperties = {};
var eventsCallstack = [];
var SEGMENT_LOADED_EVENT = 'segment_loaded';
function getMandatoryProperties() {
  return cachedProperties;
}
function flushEventsCallstack() {
  var eventsToRun = (0, _toConsumableArray2["default"])(eventsCallstack);
  eventsCallstack = [];
  eventsToRun.forEach(function (callback) {
    callback();
  });
}
function setCollectUntrackedEvents(enabled) {
  settings.collectUntrackedEvents = enabled;
}
function getUserEmailFromSegmentLibrary() {
  var _window$analytics4;
  var segmentUserData = (_window$analytics4 = window.analytics) === null || _window$analytics4 === void 0 ? void 0 : _window$analytics4.user;
  if (typeof segmentUserData !== 'undefined') {
    var userTraits = segmentUserData().traits();
    return userTraits.email || null;
  }
}
function ensureEmailIsSentIfAvailable(properties) {
  if (properties && !properties.email) {
    var userIsUnknown = userData.email === null;
    if (userIsUnknown) {
      userData.email = getUserEmailFromSegmentLibrary() || null;
    }
    if (userData.email !== null) properties.email = userData.email;
  }
}
function showInitWarning(trackingFn, callback) {
  var error = "init was not called with mandatoryProperties. Cannot call ".concat(trackingFn, ". Please call init with the mandatoryProperties.");
  _logger["default"].warn(error);
  callback && callback({
    error: error
  });
}
function initRudderstackTracking(config) {
  if (!config.dataPlaneUrl) {
    _logger["default"].warn("Rudderstack tracking could not be initialised because 'config.dataPlaneUrl' is not valid.");
    return;
  }
  if (!isInitialized(SUPPORTED_PROVIDERS.RUDDERSTACK)) {
    require('./rudderstack/script-loader');
    require('./rudderstack/snippet');
    var dataPlaneUrl = config.dataPlaneUrl,
      key = config.key,
      options = config.options;
    window.rudderanalytics.load(key, dataPlaneUrl, options);
    if (settings.collectUntrackedEvents) {
      window.rudderanalytics.ready(flushEventsCallstack);
    }
  }
}
function initSegmentTracking(config) {
  var key = config.key,
    options = config.options;
  if (!isInitialized(SUPPORTED_PROVIDERS.SEGMENT)) {
    require('./snippet');
    window.analytics.load(key, options);
    window.dataLayer.push({
      event: SEGMENT_LOADED_EVENT
    });
    window.analytics.ready( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            window.analytics.allInitsReady = true;
            if (settings.collectUntrackedEvents) {
              flushEventsCallstack();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
  }
}
function initializeProvider(provider) {
  var name = provider.name,
    config = provider.config;
  if (isInitialized(name)) {
    return;
  }
  if (!config) {
    _logger["default"].warn("".concat(name, " tracking cannot be initialised because no config was provided"));
    return;
  }
  if (!config.key) {
    _logger["default"].warn("".concat(name, " tracking cannot be initialised because 'config.key' is not valid"));
    return;
  }
  try {
    switch (name) {
      case _constants.RUDDERSTACK:
        initRudderstackTracking(config);
        break;
      case _constants.SEGMENT:
      default:
        initSegmentTracking(config);
        break;
    }
  } catch (error) {
    _logger["default"].error("There was an error when initialising ".concat(name, " tracking. Please report this error to the library maintainers: "), error);
    return;
  }
}
function loadAnalytics(providers, mandatoryProperties) {
  var _window3;
  if (!providers || Array.isArray(providers) && !providers.length) {
    _logger["default"].error('There was an error when initialising tracking. No tracking providers were provided');
    return;
  }

  // Never initialize tracking if the request is from a bot.
  if ((0, _isUserAgentFromABot.isUserAgentFromABot)((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.navigator) === null || _window3 === void 0 ? void 0 : _window3.userAgent)) {
    _logger["default"].info('Unable to initialize tracking - client does not meet requirements');
    return;
  }
  if (mandatoryProperties) {
    updateMandatoryProperties(mandatoryProperties);
  }
  if (Array.isArray(providers)) {
    providers.forEach(function (provider) {
      provider && initializeProvider(provider);
    });
    return;
  }
  initializeProvider(providers);
  return;
}

/**
 * Initializes Segment tracking.
 *
 * @param initSessionReplay - Deprecated. Has no effect. Kept to avoid a breaking change.
 */
function loadAnalyticsWithConsent(apiKey, mandatoryProperties) {
  var _window4;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var gtmId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.GTM_ID;
  var initSessionReplay = arguments.length > 4 ? arguments[4] : undefined;
  // Never initialize tracking if the request is from a bot.
  if ((0, _isUserAgentFromABot.isUserAgentFromABot)((_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.navigator) === null || _window4 === void 0 ? void 0 : _window4.userAgent)) {
    _logger["default"].info('Unable to initialize tracking - client does not meet requirements');
    return;
  }
  if (!(0, _snippetGtm.hasLoaded)(gtmId)) {
    (0, _snippetGtm.load)(gtmId);
  }
  settings.dataLayerPush = true;
  if (mandatoryProperties) {
    updateMandatoryProperties(mandatoryProperties);
  }
  var userConsentedTracking = (0, _consentUtil.hasConsentCookie)() && (0, _consentUtil.hasPerformanceConsent)();
  if (!userConsentedTracking) {
    return;
  }
  options['integrations'] = _objectSpread(_objectSpread({}, options === null || options === void 0 ? void 0 : options.integrations), {}, {
    'Actions Amplitude': true,
    'FullStory': true
  });
  initSegmentTracking({
    key: apiKey,
    options: options
  });
}
function updateMandatoryProperties(mandatoryProperties) {
  if (mandatoryProperties) {
    cachedProperties = _objectSpread(_objectSpread({}, cachedProperties), mandatoryProperties);
  }
}
function isInitialized() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SEGMENT;
  return settings.providers[provider].initialized();
}
function isLoading() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SEGMENT;
  return settings.providers[provider].isLoading();
}
function isReady() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SEGMENT;
  return settings.providers[provider].ready();
}
function identify(userId, traits, options, callback) {
  if (!isInitialized(_constants.SEGMENT)) {
    callback && callback();
    return;
  }
  if (traits && traits.email) {
    userData.email = traits.email;
  }
  window.analytics.identify(userId, traits, options, callback);
}
function group(accountUid, traits, options, callback) {
  if (isInitialized(_constants.SEGMENT)) {
    window.analytics.group(accountUid, traits, options, callback);
  } else {
    callback && callback();
  }
}
function reset() {
  if (isInitialized(_constants.SEGMENT)) {
    window.analytics.reset();
  }
  if (isInitialized(_constants.RUDDERSTACK)) {
    window.rudderanalytics.reset();
  }
}
function deepMerge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  sources.forEach(function (source) {
    if (source == null) {
      return; // Skip this source as it's not an object
    }

    Object.keys(source).forEach(function (key) {
      var sourceKey = key;
      if (source[sourceKey] && (0, _typeof2["default"])(source[sourceKey]) === 'object' && !Array.isArray(source[sourceKey])) {
        if (!target[sourceKey]) target[sourceKey] = {};
        deepMerge(target[sourceKey], source[sourceKey]);
      } else {
        target[sourceKey] = source[sourceKey];
      }
    });
  });
  return target;
}

/**
 * Extracts the part of the URL before the query string and hash, handling invalid URLs gracefully.
 * @param url The input URL string to process.
 * @returns The URL up to the pathname, excluding the query string and the hash.
 */
var getUrlWithoutQueryAndHash = function getUrlWithoutQueryAndHash(url) {
  try {
    var urlObj = new URL(url);
    return urlObj.origin + urlObj.pathname; // Returns only the origin and pathname, excluding search and hash
  } catch (_unused) {
    // Return the original URL if it's invalid
    return url;
  }
};

/**
 * Retrieves the document's referrer URL without the query string and hash,
 * defaulting to '$direct' if no referrer is present or the document is undefined (this is what rudderstack js sdk v1 does).
 * @returns The referrer URL up to the pathname, excluding the query string and hash.
 */
var getReferrerWithoutQuery = function getReferrerWithoutQuery() {
  var _document;
  var ref = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
  if (!ref) return '$direct';
  try {
    return getUrlWithoutQueryAndHash(ref);
  } catch (_unused2) {
    // If the URL is invalid, return original ref
    return ref;
  }
};

/**
 * Retrieves the current tab's URL without the query string and hash.
 * @returns The URL of the current tab up to the pathname, excluding the query string and hash.
 */
var getTabUrlWithoutQuery = function getTabUrlWithoutQuery() {
  try {
    var url = globalThis.location.href; // Access the current URL
    return getUrlWithoutQueryAndHash(url);
  } catch (_unused3) {
    // Fallback to the full href URL is not valid
    return globalThis.location.href;
  }
};
function sendEventToRudderstack(eventName, properties, options, callback) {
  var referrer = getReferrerWithoutQuery();
  var tabUrl = getTabUrlWithoutQuery();
  var url = getUrlWithoutQueryAndHash(tabUrl);
  var optionsToRemovePotentialPII = {
    context: {
      page: {
        referrer: referrer,
        search: null,
        tab_url: tabUrl,
        url: url
      }
    }
  };
  options = deepMerge({}, options, optionsToRemovePotentialPII);
  window.rudderanalytics.track(eventName, properties, options, callback);
}
function sendEventToSegment(eventName, properties, options, callback) {
  ensureEmailIsSentIfAvailable(properties);
  window.analytics.track(eventName, properties, options, callback);
}
function collectEvent(eventName, properties, options, callback) {
  var _eventsCallstack;
  (_eventsCallstack = eventsCallstack) === null || _eventsCallstack === void 0 || _eventsCallstack.push(function () {
    sendEvent(eventName, properties, options, callback);
  });
}
function sendEvent(eventName, properties, options, callback) {
  var readyProviders = Object.values(SUPPORTED_PROVIDERS).filter(isReady);
  var isThereAnyReadyProvider = readyProviders.length > 0;
  var isThereAnyProviderLoading = Object.values(SUPPORTED_PROVIDERS).some(isLoading);
  if (!isThereAnyReadyProvider) {
    var _callback;
    if (!isThereAnyProviderLoading) {
      _logger["default"].warn('sendEvent was called when trackingService has not been initialized', {
        eventName: eventName,
        properties: properties,
        options: options
      });
    }
    if (typeof properties === 'function') {
      callback = properties;
    }
    if (typeof options === 'function') {
      callback = options;
    }
    (_callback = callback) === null || _callback === void 0 || _callback();
    if (settings.collectUntrackedEvents) {
      collectEvent(eventName, properties, options, callback);
    }
    return;
  }
  if ((0, _typeof2["default"])(properties) !== 'object') {
    _logger["default"].warn('sendEvent called without properties');
  }
  ensureEmailIsSentIfAvailable(properties);
  if (settings.dataLayerPush) {
    window.dataLayer.push(_objectSpread({
      event: eventName
    }, properties));
  }

  /*
    We chain promises for each provider and only execute the callback
    once all of them are done (even if they're rejected, we don't want
    to block so we execute the callback anyways)
  */
  return Promise.all(readyProviders.map(function (provider) {
    return new Promise(function (resolve, reject) {
      try {
        switch (provider) {
          case _constants.RUDDERSTACK:
            sendEventToRudderstack(eventName, properties, options, resolve);
            break;
          case _constants.SEGMENT:
          default:
            sendEventToSegment(eventName, properties, options, resolve);
        }
      } catch (err) {
        _logger["default"].warn("An error occurred while tracking on ".concat(provider, ": ").concat(err));
        reject(err);
      }
    });
  }))["finally"](function () {
    callback && callback();
  });
}
function sendPage(pageName, properties) {
  if (isInitialized(_constants.SEGMENT)) window.analytics.page(pageName, properties);
}
function setUserProperties(userId, properties, callback) {
  if (isInitialized(_constants.SEGMENT)) {
    if (properties && properties.email) userData.email = properties.email;
    window.analytics.identify(userId, properties, {}, callback);
  } else {
    callback && callback();
  }
}
function incrementUserProperty(userId, properties) {
  if (isInitialized(_constants.SEGMENT)) {
    window.analytics.identify(userId, {}, {
      integrations: {
        Intercom: {
          increments: properties
        }
      }
    });
  }
}
function updateWidget() {
  if (isInitialized(_constants.SEGMENT) && typeof window.Intercom !== 'undefined') window.Intercom('update');
}
function sendOrder(data) {
  if (isInitialized(_constants.SEGMENT)) {
    window.analytics.track('Added Product', data.product);
    window.analytics.track('Completed Order', {
      orderId: data.transactionId,
      total: data.total,
      revenue: data.total,
      currency: data.currency,
      label: data.sku,
      products: [data.product]
    });
  }
}
function trackPresentConversation(_ref2, options, callback) {
  var attribution_uid = _ref2.attribution_uid,
    _ref2$distribution_ch = _ref2.distribution_channel,
    distribution_channel = _ref2$distribution_ch === void 0 ? 'standard' : _ref2$distribution_ch,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  if (!attribution_uid) {
    var error = 'The attribution_uid property is mandatory. Cannot call trackPresentConversation. Please send with the attribution_uid property';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('present_conversation', _objectSpread({
    attribution_uid: attribution_uid,
    distribution_channel: distribution_channel
  }, rest), options, callback);
}
function trackStartConversation(_ref3, options, callback) {
  var attribution_uid = _ref3.attribution_uid,
    _ref3$distribution_ch = _ref3.distribution_channel,
    distribution_channel = _ref3$distribution_ch === void 0 ? 'standard' : _ref3$distribution_ch,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  if (!attribution_uid) {
    var error = 'The attribution_uid property is mandatory. Cannot call trackStartConversation. Please send with the attribution_uid property';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('start_conversation', _objectSpread({
    attribution_uid: attribution_uid,
    distribution_channel: distribution_channel
  }, rest), options, callback);
}
function trackAbTest(_ref4, options, callback) {
  var test_id = _ref4.test_id,
    variant_id = _ref4.variant_id,
    variant_label = _ref4.variant_label,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded3);
  if (!variant_label) {
    if (variant_id) {
      var error = 'trackAbTest was called with variant_id instead of variant_label. Please call with a variant_label.';
      _logger["default"].warn(error);
      variant_label = variant_id.toString();
    } else {
      var _error = 'trackAbTest was called without a variant_label. Cannot call trackAbTest. Please call with a variant_label.';
      _logger["default"].warn(_error);
      callback && callback({
        error: _error
      });
      return;
    }
  }
  if (variant_label === _constants.OUT_OF_EXPERIMENT) {
    callback && callback();
    return;
  }
  sendEvent('ab_test', _objectSpread(_objectSpread({
    test_id: test_id,
    variant_label: variant_label
  }, cachedProperties), rest), options, callback);
}
function trackCreateTypeform(_ref5, options, callback) {
  var _ref5$category = _ref5.category,
    category = _ref5$category === void 0 ? 'admin' : _ref5$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded4);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackCreateTypeform', callback);
  }
  sendEvent('create_typeform', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackTypeformDeleted(_ref6, options, callback) {
  var _ref6$category = _ref6.category,
    category = _ref6$category === void 0 ? 'admin' : _ref6$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref6, _excluded5);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTypeformDeleted', callback);
  }
  sendEvent('typeform_deleted', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackPublishTypeform(_ref7, options, callback) {
  var _ref7$category = _ref7.category,
    category = _ref7$category === void 0 ? 'admin' : _ref7$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref7, _excluded6);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPublishTypeform', callback);
  }
  sendEvent('publish_typeform', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackChangeDesign(_ref8, options, callback) {
  var _ref8$category = _ref8.category,
    category = _ref8$category === void 0 ? 'admin' : _ref8$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref8, _excluded7);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackChangeDesign', callback);
  }
  sendEvent('change_design', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackUseFeature(_ref9, options, callback) {
  var _ref9$category = _ref9.category,
    category = _ref9$category === void 0 ? 'admin' : _ref9$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref9, _excluded8);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackUseFeature', callback);
  }
  sendEvent('use_feature', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackIntegrationSetup(_ref10, options, callback) {
  var _ref10$category = _ref10.category,
    category = _ref10$category === void 0 ? 'admin' : _ref10$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref10, _excluded9);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackIntegrationSetup', callback);
  }
  sendEvent('integration_setup', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackIntegrationUsed(_ref11, options, callback) {
  var _ref11$category = _ref11.category,
    category = _ref11$category === void 0 ? 'admin' : _ref11$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref11, _excluded10);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackIntegrationUsed', callback);
  }
  sendEvent('integration_used', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackItemClicked(_ref12, options, callback) {
  var _ref12$category = _ref12.category,
    category = _ref12$category === void 0 ? 'admin' : _ref12$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref12, _excluded11);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackItemClicked', callback);
  }
  sendEvent('item_clicked', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackVaXsellingClicked(properties, options, callback) {
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackVaXSellingClicked', callback);
  }
  sendEvent('va_xselling_clicked', _objectSpread(_objectSpread({}, cachedProperties), properties), options, callback);
}
function trackVaXsellingViewed(properties, options, callback) {
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackVaXsellingViewed', callback);
  }
  sendEvent('va_xselling_viewed', _objectSpread(_objectSpread({}, cachedProperties), properties), options, callback);
}
function trackSaveFailed(_ref13, options, callback) {
  var _ref13$category = _ref13.category,
    category = _ref13$category === void 0 ? 'admin' : _ref13$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref13, _excluded12);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackSaveFailed', callback);
  }
  sendEvent('form_save_failed', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackViewPageSection(_ref14, options, callback) {
  var _ref14$category = _ref14.category,
    category = _ref14$category === void 0 ? 'admin' : _ref14$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref14, _excluded13);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackViewPageSection', callback);
  }
  sendEvent('view_page_section', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackPopupOpened(_ref15, options, callback) {
  var _ref15$category = _ref15.category,
    category = _ref15$category === void 0 ? 'admin' : _ref15$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref15, _excluded14);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPopupOpened', callback);
  }
  sendEvent('popup_opened', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackPopupClosed(_ref16, options, callback) {
  var _ref16$category = _ref16.category,
    category = _ref16$category === void 0 ? 'admin' : _ref16$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref16, _excluded15);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPopupClosed', callback);
  }
  sendEvent('popup_closed', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackMenuOpened(_ref17, options, callback) {
  var _ref17$category = _ref17.category,
    category = _ref17$category === void 0 ? 'admin' : _ref17$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref17, _excluded16);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackMenuOpened', callback);
  }
  sendEvent('menu_opened', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackAccountSwitched(_ref18, options, callback) {
  var _ref18$category = _ref18.category,
    category = _ref18$category === void 0 ? 'admin' : _ref18$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref18, _excluded17);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackAccountSwitched', callback);
  }
  sendEvent('account_switched', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackBlockDefined(_ref19, options, callback) {
  var _ref19$category = _ref19.category,
    category = _ref19$category === void 0 ? 'admin' : _ref19$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref19, _excluded18);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackBlockDefined', callback);
  }
  sendEvent('block_defined', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackBlockDeleted(_ref20, options, callback) {
  var _ref20$category = _ref20.category,
    category = _ref20$category === void 0 ? 'admin' : _ref20$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref20, _excluded19);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackBlockDeleted', callback);
  }
  sendEvent('block_deleted', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackWorkspaceCreated(_ref21, options, callback) {
  var _ref21$category = _ref21.category,
    category = _ref21$category === void 0 ? 'admin' : _ref21$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref21, _excluded20);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackWorkspaceCreated', callback);
  }
  sendEvent('workspace_created', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackPanelOpened(_ref22, options, callback) {
  var _ref22$category = _ref22.category,
    category = _ref22$category === void 0 ? 'admin' : _ref22$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref22, _excluded21);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPanelOpened', callback);
  }
  sendEvent('panel_opened', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackProTrialStarted(_ref23, options, callback) {
  var _ref23$category = _ref23.category,
    category = _ref23$category === void 0 ? 'admin' : _ref23$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref23, _excluded22);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackProTrialStarted', callback);
  }
  sendEvent('pro_trial_started', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackAnswerChanged(properties, options, callback) {
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackAnswerChanged', callback);
  }
  sendEvent('answer_changed', _objectSpread(_objectSpread({}, cachedProperties), properties), options, callback);
}
function sendEventWithCache(eventName, properties, options, callback) {
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('sendEventWithCache', callback);
  }
  var category = properties.category || 'admin';
  sendEvent(eventName, _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), properties), options, callback);
}
function trackMarketingPurchaseCompleted(_ref24, options, callback) {
  var _ref24$category = _ref24.category,
    category = _ref24$category === void 0 ? 'admin' : _ref24$category,
    page = _ref24.page,
    section = _ref24.section,
    rest = (0, _objectWithoutProperties2["default"])(_ref24, _excluded23);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackMarketingPurchaseCompleted', callback);
  }
  sendEvent('mkt_purchase_completed', _objectSpread(_objectSpread({
    category: category,
    page: page,
    section: section
  }, cachedProperties), rest), options, callback);
}
function trackSurfaceOpened(_ref25, options, callback) {
  var _ref25$category = _ref25.category,
    category = _ref25$category === void 0 ? 'admin' : _ref25$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref25, _excluded24);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackSurfaceOpened', callback);
  }
  sendEvent('surface_opened', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackSearchQueryEntered(_ref26, options, callback) {
  var _ref26$category = _ref26.category,
    category = _ref26$category === void 0 ? 'admin' : _ref26$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref26, _excluded25);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackSearchQueryEntered', callback);
  }
  sendEvent('search_query_entered', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackSearchQueryRemoved(_ref27, options, callback) {
  var _ref27$category = _ref27.category,
    category = _ref27$category === void 0 ? 'admin' : _ref27$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref27, _excluded26);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackSearchQueryRemoved', callback);
  }
  sendEvent('search_query_removed', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackTmpUseFeature(_ref28, options, callback) {
  var _ref28$category = _ref28.category,
    category = _ref28$category === void 0 ? 'admin' : _ref28$category,
    test_id = _ref28.test_id,
    feature = _ref28.feature,
    rest = (0, _objectWithoutProperties2["default"])(_ref28, _excluded27);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTmpUseFeature', callback);
  }
  if (!test_id || !feature) {
    var error = '"test_id" and "feature" properties are mandatory. Cannot call trackTmpUseFeature.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('tmp_use_feature', _objectSpread(_objectSpread({
    category: category,
    test_id: test_id,
    feature: feature
  }, cachedProperties), rest), options, callback);
}
function trackTmpPopupOpened(_ref29, options, callback) {
  var _ref29$category = _ref29.category,
    category = _ref29$category === void 0 ? 'admin' : _ref29$category,
    test_id = _ref29.test_id,
    popup = _ref29.popup,
    rest = (0, _objectWithoutProperties2["default"])(_ref29, _excluded28);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTmpPopupOpened', callback);
  }
  if (!test_id || !popup) {
    var error = '"test_id" and "popup" properties are mandatory. Cannot call trackTmpPopupOpened.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('tmp_popup_opened', _objectSpread(_objectSpread({
    category: category,
    test_id: test_id,
    popup: popup
  }, cachedProperties), rest), options, callback);
}
function trackTmpItemClicked(_ref30, options, callback) {
  var _ref30$category = _ref30.category,
    category = _ref30$category === void 0 ? 'admin' : _ref30$category,
    test_id = _ref30.test_id,
    item = _ref30.item,
    rest = (0, _objectWithoutProperties2["default"])(_ref30, _excluded29);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTmpItemClicked', callback);
  }
  if (!test_id || !item) {
    var error = '"test_id" and "item" properties are mandatory. Cannot call trackTmpItemClicked.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('tmp_item_clicked', _objectSpread(_objectSpread({
    category: category,
    test_id: test_id,
    item: item
  }, cachedProperties), rest), options, callback);
}
function trackTmpViewPageSection(_ref31, options, callback) {
  var _ref31$category = _ref31.category,
    category = _ref31$category === void 0 ? 'admin' : _ref31$category,
    test_id = _ref31.test_id,
    page = _ref31.page,
    section = _ref31.section,
    rest = (0, _objectWithoutProperties2["default"])(_ref31, _excluded30);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTmpViewPageSection', callback);
  }
  if (!test_id || !page || !section) {
    var error = '"test_id", "page" and "section" properties are mandatory. Cannot call trackTmpViewPageSection.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('tmp_view_page_section', _objectSpread(_objectSpread({
    category: category,
    test_id: test_id,
    page: page,
    section: section
  }, cachedProperties), rest), options, callback);
}
function trackTmpMessageShown(_ref32, options, callback) {
  var _ref32$category = _ref32.category,
    category = _ref32$category === void 0 ? 'admin' : _ref32$category,
    test_id = _ref32.test_id,
    message = _ref32.message,
    rest = (0, _objectWithoutProperties2["default"])(_ref32, _excluded31);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTmpMessageShown', callback);
  }
  if (!test_id || !message) {
    var error = '"test_id" and "message" properties are mandatory. Cannot call trackTmpMessageShown.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('tmp_message_shown', _objectSpread(_objectSpread({
    category: category,
    test_id: test_id,
    message: message
  }, cachedProperties), rest), options, callback);
}
function trackMessageShown(_ref33, options, callback) {
  var _ref33$category = _ref33.category,
    category = _ref33$category === void 0 ? 'admin' : _ref33$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref33, _excluded32);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackMessageShown', callback);
  }
  sendEvent('message_shown', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackTmpPageNavigated(_ref34, options, callback) {
  var test_id = _ref34.test_id,
    item = _ref34.item,
    value = _ref34.value,
    location = _ref34.location,
    rest = (0, _objectWithoutProperties2["default"])(_ref34, _excluded33);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTmpPageNavigated', callback);
  }
  if (!test_id || !item || !value || !location) {
    var error = '"test_id", "item", "value" and "location" properties are mandatory. Cannot call trackTmpPageNavigated.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('tmp_page_navigated', _objectSpread(_objectSpread(_objectSpread({}, cachedProperties), rest), {}, {
    item: item,
    location: location,
    test_id: test_id,
    value: value
  }), options, callback);
}
function trackPageNavigated(_ref35, options, callback) {
  var item = _ref35.item,
    location = _ref35.location,
    page = _ref35.page,
    section = _ref35.section,
    rest = (0, _objectWithoutProperties2["default"])(_ref35, _excluded34);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPageNavigated', callback);
  }
  if (!item || !location || !page || !section) {
    var error = '"item", "location", "page" and "section" properties are mandatory. Cannot call trackPageNavigated.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('page_navigated', _objectSpread(_objectSpread(_objectSpread({}, cachedProperties), rest), {}, {
    item: item,
    location: location,
    page: page,
    section: section
  }), options, callback);
}
function trackPageClosed(_ref36, options, callback) {
  var page = _ref36.page,
    section = _ref36.section,
    _ref36$category = _ref36.category,
    category = _ref36$category === void 0 ? 'admin' : _ref36$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref36, _excluded35);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPageClosed', callback);
  }
  sendEvent('page_closed', _objectSpread(_objectSpread({
    page: page,
    section: section,
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackBrowserZoomed(_ref37, options, callback) {
  var zoom_type = _ref37.zoom_type,
    zoom_percentage = _ref37.zoom_percentage,
    _ref37$category = _ref37.category,
    category = _ref37$category === void 0 ? 'admin' : _ref37$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref37, _excluded36);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackBrowserZoomed', callback);
  }
  if (!zoom_type || !zoom_percentage || !category) {
    var error = '"zoom_type", "zoom_percentage", "category" properties are mandatory. Cannot call trackBrowserZoomed.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('browser_zoomed', _objectSpread(_objectSpread({
    zoom_type: zoom_type,
    zoom_percentage: zoom_percentage,
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackPublishTypeformFailed(_ref38, options, callback) {
  var _ref38$category = _ref38.category,
    category = _ref38$category === void 0 ? 'admin' : _ref38$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref38, _excluded37);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackPublishTypeformFailed', callback);
  }
  sendEvent('publish_typeform_failed', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackModalOpened(_ref39, options, callback) {
  var _ref39$category = _ref39.category,
    category = _ref39$category === void 0 ? 'admin' : _ref39$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref39, _excluded38);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackModalOpened', callback);
  }
  sendEvent('modal_opened', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackAutobrandingApi(_ref40, options, callback) {
  var api_call_response = _ref40.api_call_response,
    company_website = _ref40.company_website,
    _ref40$category = _ref40.category,
    category = _ref40$category === void 0 ? 'admin' : _ref40$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref40, _excluded39);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackAutobrandingApi', callback);
  }
  if (!api_call_response || !company_website) {
    var error = '"api_call_response" and "company_website" properties are mandatory. Cannot call trackAutobrandingApi.';
    _logger["default"].warn(error);
    callback && callback({
      error: error
    });
    return;
  }
  sendEvent('autobranding_api', _objectSpread(_objectSpread({
    api_call_response: api_call_response,
    company_website: company_website,
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackMediaQuestionDefined(_ref41, options, callback) {
  var _ref41$category = _ref41.category,
    category = _ref41$category === void 0 ? 'admin' : _ref41$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref41, _excluded40);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackMediaQuestionDefined', callback);
  }
  sendEvent('media_question_defined', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackGenerativeAiApi(_ref42, options, callback) {
  var _ref42$category = _ref42.category,
    category = _ref42$category === void 0 ? 'admin' : _ref42$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref42, _excluded41);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackGenerativeAiApi', callback);
  }
  sendEvent('generative_ai_api', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackLoginRedirected(_ref43, options, callback) {
  var _ref43$category = _ref43.category,
    category = _ref43$category === void 0 ? 'admin' : _ref43$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref43, _excluded42);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackLoginRedirected', callback);
  }
  sendEvent('login_redirected', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackFeatureDiscovered(_ref44, options, callback) {
  var _ref44$category = _ref44.category,
    category = _ref44$category === void 0 ? 'admin' : _ref44$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref44, _excluded43);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackFeatureDiscovered', callback);
  }
  sendEvent('feature_discovered', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackFeatureActivated(_ref45, options, callback) {
  var _ref45$category = _ref45.category,
    category = _ref45$category === void 0 ? 'admin' : _ref45$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref45, _excluded44);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackFeatureActivated', callback);
  }
  sendEvent('feature_activated', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackFeatureFirstStepAdopted(_ref46, options, callback) {
  var _ref46$category = _ref46.category,
    category = _ref46$category === void 0 ? 'admin' : _ref46$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref46, _excluded45);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackFeatureFirstStepAdopted', callback);
  }
  sendEvent('feature_first_step_adopted', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
function trackTypeformModeChanged(_ref47, options, callback) {
  var _ref47$category = _ref47.category,
    category = _ref47$category === void 0 ? 'admin' : _ref47$category,
    rest = (0, _objectWithoutProperties2["default"])(_ref47, _excluded46);
  if (!Object.keys(cachedProperties).length) {
    return showInitWarning('trackTypeformModeChanged', callback);
  }
  sendEvent('typeform_mode_changed', _objectSpread(_objectSpread({
    category: category
  }, cachedProperties), rest), options, callback);
}
var trackingService = {
  getMandatoryProperties: getMandatoryProperties,
  group: group,
  identify: identify,
  incrementUserProperty: incrementUserProperty,
  init: loadAnalyticsWithConsent,
  initRenderer: loadAnalytics,
  isInitialized: isInitialized,
  reset: reset,
  sendEvent: sendEvent,
  sendEventWithCache: sendEventWithCache,
  sendOrder: sendOrder,
  sendPage: sendPage,
  setUserProperties: setUserProperties,
  trackAbTest: trackAbTest,
  trackAccountSwitched: trackAccountSwitched,
  trackAnswerChanged: trackAnswerChanged,
  trackAutobrandingApi: trackAutobrandingApi,
  trackBlockDefined: trackBlockDefined,
  trackBlockDeleted: trackBlockDeleted,
  trackBrowserZoomed: trackBrowserZoomed,
  trackChangeDesign: trackChangeDesign,
  trackCreateTypeform: trackCreateTypeform,
  trackFeatureActivated: trackFeatureActivated,
  trackFeatureDiscovered: trackFeatureDiscovered,
  trackFeatureFirstStepAdopted: trackFeatureFirstStepAdopted,
  trackGenerativeAiApi: trackGenerativeAiApi,
  trackIntegrationSetup: trackIntegrationSetup,
  trackIntegrationUsed: trackIntegrationUsed,
  trackItemClicked: trackItemClicked,
  trackLoginRedirected: trackLoginRedirected,
  trackMarketingPurchaseCompleted: trackMarketingPurchaseCompleted,
  trackMediaQuestionDefined: trackMediaQuestionDefined,
  trackMenuOpened: trackMenuOpened,
  trackMessageShown: trackMessageShown,
  trackModalOpened: trackModalOpened,
  trackPageClosed: trackPageClosed,
  trackPageNavigated: trackPageNavigated,
  trackPanelOpened: trackPanelOpened,
  trackPopupClosed: trackPopupClosed,
  trackPopupOpened: trackPopupOpened,
  trackPresentConversation: trackPresentConversation,
  trackProTrialStarted: trackProTrialStarted,
  trackPublishTypeform: trackPublishTypeform,
  trackPublishTypeformFailed: trackPublishTypeformFailed,
  trackSaveFailed: trackSaveFailed,
  trackSearchQueryEntered: trackSearchQueryEntered,
  trackSearchQueryRemoved: trackSearchQueryRemoved,
  trackStartConversation: trackStartConversation,
  trackSurfaceOpened: trackSurfaceOpened,
  trackTmpItemClicked: trackTmpItemClicked,
  trackTmpMessageShown: trackTmpMessageShown,
  trackTmpPageNavigated: trackTmpPageNavigated,
  trackTmpPopupOpened: trackTmpPopupOpened,
  trackTmpUseFeature: trackTmpUseFeature,
  trackTmpViewPageSection: trackTmpViewPageSection,
  trackTypeformDeleted: trackTypeformDeleted,
  trackTypeformModeChanged: trackTypeformModeChanged,
  trackUseFeature: trackUseFeature,
  trackVaXsellingClicked: trackVaXsellingClicked,
  trackVaXsellingViewed: trackVaXsellingViewed,
  trackViewPageSection: trackViewPageSection,
  trackWorkspaceCreated: trackWorkspaceCreated,
  updateMandatoryProperties: updateMandatoryProperties,
  updateWidget: updateWidget
};
var _default = exports["default"] = trackingService;